import { Link } from "react-router-dom";
import styled, { keyframes } from "styled-components";
import { hexToRgba } from "../HexToRGBA";

// Styled components for the split layout
export const AuthContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  align-content: center;
  min-height: 80vh;
  padding: 20px;
  background: ${(props) => props.theme.mainBg};
`;

export const SplitWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 40px;
  max-width: 900px;
  width: 100%;
  margin-top: 30px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 20px;
  }
`;

export const OptionCard = styled.div`
  flex: 1;
  background: ${(props) => props.theme.background};
  border: 1px solid ${(props) => props.theme.accentColor}30;
  border-radius: 12px;
  padding: 30px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  transition: transform 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    border-color: ${(props) => props.theme.mainColor};
  }
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 20px;
  margin-bottom: 20px;
`;

export const StyledInput = styled.input`
  padding: 12px;
  border-radius: 8px;
  border: 1px solid ${(props) => props.theme.accentColor}40;
  background: ${(props) => props.theme.mainBg};
  color: ${(props) => props.theme.secondaryBg};
  font-size: 1rem;

  &:focus {
    outline: none;
    border-color: ${(props) => props.theme.mainColor};
  }
`;

export const Divider = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  color: ${(props) => props.theme.accentColor};
  font-weight: bold;

  @media (min-width: 769px) {
    flex-direction: column;
    justify-content: center;
    &::before, &::after {
      content: '';
      flex: 1;
      width: 1px;
      background: ${(props) => props.theme.accentColor}40;
      margin: 10px 0;
    }
  }

  @media (max-width: 768px) {
    width: 100%;
    margin: 10px 0;
    &::before, &::after {
      content: '';
      flex: 1;
      height: 1px;
      background: ${(props) => props.theme.accentColor}40;
      margin: 0 10px;
    }
  }
`;

export const Container = styled.div`
display: flex;
flex-direction: column;
overflow: hidden;
  min-height:100vh;
  align-items:center;
  align-content: center;
  justify-content: center;
  backdrop-filter: blur(5px);
-webkit-backdrop-filter: blur(5px);

  background: linear-gradient(180deg, rgba(179, 111, 247, 0.76) 0%, rgba(84, 120, 154, 0.6232) 100%);
  `;

  export const VideoBg = styled.video`
  display: flex;
  position: absolute;
  flex-direction: column;
  align-items:center;
  justify-content: center;
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
  background: ${props => hexToRgba(props.theme.mainBg, 0.3)};
  `

  export const ContentWrapper = styled.div`
  display: flex;
  align-items:center;
  align-content: center;
  justify-content: center;
  padding: 8%;
  backdrop-filter: blur(25px);
  -webkit-backdrop-filter: blur(25px);
  width: 100%;
  min-height 100vh;
  overflow: hidden;
  background: ${props => hexToRgba(props.theme.mainBg, 0.3)};
  `
export const FormWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items:center;
  justify-content: center;
`;
export const QrWrapper = styled.a`
  display:flex;
  align-content: center;
  justify-content: center;
  display: flex;
  margin-bottom: 30px;
`;

export const QrCode = styled.img`
  display:flex;
  align-content: center;
  justify-content: center;

  @media screen and (max-width: 480px) {
    width: 80%;
  }
`;

export const Icon = styled(Link)`
  margin-left: 32px;
  margin-top: 32px;
  text-decoration: none;
  color: ${(props) => props.theme.secondaryBg};
  font-weight: 200;
  font-size: 32px;

  @media screen and (max-width: 480px) {
    margin-left: 16px;
    margin-top: 8px;
  }
`;
export const FormContent = styled.div`
  
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media screen and (max-width: 480px) {
    padding: 10px;
	
  }
`;
export const Form = styled.form`
  display: flex;
  backdrop-filter: blur(5px);
  flex-direction: column;
  -webkit-backdrop-filter: blur(5px);
  background: ${(props) => hexToRgba(props.theme.mainBg, 0.6)};
  min-width: 400px;
  padding: 10% 6%;
  border-radius: 3%;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.9);
`;

export const FormH1 = styled.h1`
  margin-bottom: 8%;;
  color: ${(props) => props.theme.secondaryBg};
  font-size: 1.3rem;
  font-weight: 400;
  text-align: center;
`;

export const FormLabel = styled.label`
  margin-bottom: 10%;
  color: ${(props) => props.theme.secondaryBg};
  font-size: 14px;
`;

export const FormInput = styled.input`
  padding: 16px 16px;
  margin-bottom: 20px;
  border: none;
  border-radius: 4px;
`;

export const FormButton = styled(Link)`
  background: ${(props) => (props.transparent ? props.theme.mainBG : props.theme.mainColor)};
  padding: 2% 1%;
  border: none;
  text-align: center;
  justify-content: center;
  align-items: center;
  border-radius: 3%;
  color: ${(props) => (props.transparent ? props.theme.accentColor : props.theme.secondaryBg)};
  font-size: 14px;
  cursor: pointer;
  margin-bottom: 15px;
  text-decoration: ${(props) => (props.transparent ? 'underline' : 'none')};


  @media screen and (max-width: 480px) {
    margin-top: 0;
    font-size: 14px;
  }
`;

export const Text = styled.span`
  text-align: center;
  color: ${(props) => props.theme.secondaryBg};
  font-size: 14px;
  margin-bottom: 10px;

  @media screen and (max-width: 480px) {
    margin-top: 0;
  }
`;
export const TextLink = styled.a`
  color: ${(props) => props.theme.accentColor};
  cursor: pointer;
  text-decoration: none;

  &:hover{
    transition: all 0.3s ease-in-out;
    text-decoration: underline;
    
  }
`;

export const TextRoute = styled(Link)`
  text-decoration: none;
  color: ${(props) => props.theme.secondaryColor};
  &:hover{
    transition: all 0.3s ease-in-out;
    text-decoration: underline;
    
  }

`

/* export const Loader = styled(PushSpinner)`
  display: flex;
  size: 30;
  text-color: ${(props) => props.theme.secondaryColor};
  color: ${(props) => props.theme.secondaryColor};
  justify-content: center;
  align-items: center;
`; */

export const Small = styled.small`
  color: ${(props) => props.theme.accentColor};
  text-align: center;
`

// --- KEYFRAME ANIMATIONS ---
const slideUp = keyframes`
  from { transform: translateY(20px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
`;

// --- STYLED COMPONENTS ---
export const WizardWrapper = styled.div`
  min-height: 100vh;
  background-color: ${props => props.theme.mainBg};
  color: ${props => props.theme.secondaryBg};
  font-family: ui-sans-serif, system-ui, -apple-system, sans-serif;
  padding: 40px 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Card = styled.div`
  max-width: 680px;
  width: 100%;
  background-color: ${props => hexToRgba(props.theme.mainBg, 0.5)};
  border: 1px solid ${props => props.theme.secondaryBg};
  border-radius: 15px;
  padding: 32px;
  box-shadow: 0 25px 50px -12px ${props => hexToRgba(props.theme.secondaryBg, 0.5)};
  box-sizing: border-box;
  animation: ${slideUp} 0.4s cubic-bezier(0.16, 1, 0.3, 1) forwards;
`;

export const StepIndicatorGroup = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  margin-bottom: 32px;
`;

export const IndicatorCircle = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  font-weight: 800;
  background-color: ${props => props.completed ? props => props.theme.successColor : props.active ? props => props.theme.mainColor : props => props.theme.background};
  color: ${props => props.active || props.completed ? props.theme.mainBg : "#475569"};
  border: ${props => props.active ? `2px solid ${props => props.theme.mainColor}` : "2px solid transparent"};
  transition: all 0.3s ease;
`;

export const IndicatorLine = styled.div`
  width: 40px;
  height: 2px;
  background-color: ${props => props.completed ? props => props.theme.successColor : "#1e293b"};
  transition: all 0.3s ease;
`;

export const CardTitle = styled.h2`
  font-size: 1.75rem;
  font-weight: 900;
  margin: 0 0 12px 0;
  text-align: center;
  color: ${props => props.theme.secondaryBg};
`;

export const DescText = styled.p`
  font-size: 0.875rem;
  color: ${props => props.theme.secondaryColor};
  line-height: 1.6;
  margin: 0 auto 32px auto;
  text-align: center;
  max-width: 520px;
`;

export const FormGroup = styled.div`
  margin-bottom: 20px;
`;


export const Input = styled.input`
  width: 100%;
  background-color: ${props => props.theme.background};
  border: 1px solid #334155;
  border-radius: 12px;
  padding: 14px 16px;
  font-size: 0.9rem;
  color: ${props => props.theme.secondaryBg};
  box-sizing: border-box;
  transition: border-color 0.2s ease;
  font-family: ${props => props.monospace ? "monospace" : "inherit"};

  &:focus {
    outline: none;
    border-color: ${props => props.theme.mainColor};
  }
`;

export const SubmitButton = styled.button`
  width: 100%;
  background-color: ${props => props.theme.mainColor};
  color: props.theme.mainBg;
  font-weight: 800;
  border: none;
  padding: 14px;
  border-radius: 12px;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  &:hover {
    opacity: 0.9;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const SecondaryButton = styled.button`
  padding: 14px 24px;
  border-radius: 12px;
  border: 1px solid ${props => props.theme.secondaryColor};
  background-color: transparent;
  color: props.theme.accentColor;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${props => hexToRgba(props.theme.secondaryBg, 0.05)};
  }
`;

export const InfoCallout = styled.div`
  background-color: ${props => hexToRgba(props.theme.secondaryBg, 0.05)};
  border-left: 4px solid ${props => props.borderColor ||  props.theme.accentColor};
  border-radius: 0 12px 12px 0;
  padding: 16px 20px;
  margin-bottom: 24px;
`;

export const CalloutTitle = styled.h4`
  font-size: 0.85rem;
  font-weight: 700;
  color: ${props => props.theme.secondaryBg};
  margin: 0 0 6px 0;
`;

export const CalloutText = styled.p`
  font-size: 0.75rem;
  color: ${props => props.theme.secondaryColor};
  line-height: 1.5;
  margin: 0;
`;

export const WarningCallout = styled.div`
  background-color: ${props => hexToRgba(props.theme.secondaryBg, 0.05)};
  border-left: 4px solid ${props => props.theme.errorColor};
  border-radius: 0 12px 12px 0;
  padding: 16px 20px;
  margin-bottom: 24px;
`;

export const SelectionGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  margin-bottom: 24px;
`;


export const OptionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
`;

export const OptionRadio = styled.div`
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 2px solid ${props => props.active ? props => props.theme.mainColor : "#475569"};
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${props => props.active ? props => props.theme.mainColor : "transparent"};
`;

export const OptionRadioInner = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${props => props.theme.background};
`;

export const OptionTitle = styled.h3`
  font-size: 0.95rem;
  font-weight: 800;
  color: ${props => props.theme.secondaryBg};
  margin: 0;
`;

export const OptionDesc = styled.p`
  font-size: 0.75rem;
  color: ${props => props.theme.secondaryColor};
  line-height: 1.5;
  margin: 0;
  padding-left: 30px;
`;

export const DynamicContainer = styled.div`
  margin-bottom: 24px;
  animation: ${slideUp} 0.2s ease-out;
`;

export const ToggleButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 8px;
`;

export const ToggleButton = styled.button`
  flex: 1;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid ${props => hexToRgba(props.theme.secondaryBg, 0.5)};
  background-color: ${props => props.active ? props => props.theme.secondaryColor : "transparent"};
  color: ${props => props.active ? props.theme.mainBg : props.theme.accentColor};
  font-size: 0.75rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${props => props.active ? props => props.theme.secondaryColor : "rgba(255, 255, 255, 0.05)"};
  }
`;

export const HelperText = styled.p`
  font-size: 11px;
  color: ${props => props.theme.secondaryColor};
  margin-top: 12px;
  line-height: 1.4;
`;

export const CheckboxWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
`;

export const CheckboxLabel = styled.label`
  font-size: 11px;
  color: ${props => props.theme.secondaryColor};
  line-height: 1.5;
  cursor: pointer;
`;

export const ButtonRow = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 24px;
`;

export const SuccessCheckCircle = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: ${props => props.theme.successColor}20;
  border: 2px solid ${props => props.theme.successColor};
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 24px auto;
  font-size: 1.75rem;
  color: ${props => props.theme.successColor};
`;

export const SummaryBox = styled.div`
  background-color: ${props => props.theme.mainBg};
  border: 1px solid ${props => hexToRgba(props.theme.secondaryColor, 0.5)};
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 24px;
  text-align: left;
`;

export const HighlightValue = styled.span`
  font-family: monospace;
  font-size: 0.85rem;
  color: ${props => props.theme.mainColor};
  display: block;
  margin-bottom: 12px;
  word-break: break-all;
`;

export const PrivateKeyValue = styled.span`
  font-family: monospace;
  font-size: 0.8rem;
  color: ${props => props.theme.secondaryColor};
  display: block;
  word-break: break-all;
`;

export const ToastContainer = styled.div`
  position: fixed;
  top: 24px;
  right: 24px;
  z-index: 100;
  max-width: 380px;
  width: calc(100% - 48px);
  background-color: ${props => props.theme.secondaryBg};
  border: 1px solid ${props => 
    props.type === "error" ? props => props.theme.errorColor : 
    props.type === "warning" ? props => props.theme.warningColor : props => props.theme.successColor
  };
  padding: 16px;
  border-radius: 12px;
  box-shadow: 0 25px 50px -12px ${props => hexToRgba(props.theme.secondaryBg, 0.5)};
  animation: ${slideUp} 0.3s cubic-bezier(0.16, 1, 0.3, 1) forwards;
`;

export const ToastTitle = styled.h4`
  margin: 0 0 4px 0;
  font-size: 0.9rem;
  font-weight: 700;
  color: ${props => 
    props.type === "error" ? props => props.theme.errorColor : 
    props.type === "warning" ? props => props.theme.warningColor : props => props.theme.successColor
  };
`;

export const ToastMessage = styled.p`
  margin: 0;
  font-size: 0.75rem;
  color: ${props => props.theme.secondaryColor};
  line-height: 1.4;
`;
